<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";

enum DiscoverNavigationEnum {
    history = "history",
    values = "values",
    licence = "licence",
}

type DiscoverNavigationProps = {
    current: string;
};

defineProps<DiscoverNavigationProps>();

const contactFormOpened = ref(false);

defineExpose({
    contactFormOpened,
});

const router = useRouter();
async function goTo(item: DiscoverNavigationEnum) {
    await router.push(`/discover/${item}`);
}
</script>

<template>
    <VFlex
        flex-direction="row"
        justify-content="center"
        column-gap="1em"
        class="p-3 has-background-white kart-navigation gradient-overlay">
        <VButton
            v-for="item in Object.values(DiscoverNavigationEnum)"
            :key="item"
            :color="item === current ? 'info' : undefined"
            class="has-border-white is-uppercase is-button-navigation is-weight-500"
            @click="goTo(item)">
            <Translate>speed2max.discover.navigation.{{ item }}</Translate>
        </VButton>
        <VButton
            color="secondary"
            class="has-border-white is-uppercase is-button-navigation is-weight-500"
            @click="contactFormOpened = true">
            <Translate>speed2max.discover.navigation.contact</Translate>
        </VButton>
        <!-- <img src="/images/kart/bg-kart.svg" alt="kart" /> -->
        <FormContactOwner v-model:open="contactFormOpened"></FormContactOwner>
    </VFlex>
</template>

<style lang="scss" scoped>
.kart-navigation {
    position: fixed;
    overflow: hidden;
    z-index: 9;
    width: calc(100% - 320px);
    overflow-x: auto;
    box-shadow: rgb(149 157 165 / 20%) 0 8px 24px;

    > img {
        right: 0;
        top: 0;
        position: absolute;
        width: 300px;
    }
}

@media screen and (max-width: 1024px) {
    .kart-navigation {
        width: 100%;
    }
}

@media screen and (max-width: 650px) {
    .kart-navigation {
        display: ruby;
        flex-wrap: nowrap;
        overflow-x: visible;

        > .is-button-navigation {
            margin: 0 10px;
        }
    }

    .kart-navigation > img {
        display: none;
    }
}
</style>
